import React, { Suspense } from 'react'
import { Outlet } from 'react-router'

import { USER_TYPE } from '../../../../types/misc'
import AuthGuard from '../../../guards/AuthGuard'
import CompanyDashboardLayout from '../CompanyDashboardLayout'
import CompassPageHeader from './components/CompassPageHeader/CompassPageHeader'

const CompanyDashboardCompanyCompassLayout: React.FC = () => (
  <AuthGuard requiredUserType={USER_TYPE.company}>
    <CompanyDashboardLayout padded>
      <div className="mw-lg">
        <CompassPageHeader />
        {/*
        The `null` fallback is intentional as we don't want to show anything
        whilst the route code is being imported. The route code import happens
        very quickly so showing a fallback doesn't make a sense and only adds
        a flicker.
        */}
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </div>
    </CompanyDashboardLayout>
  </AuthGuard>
)

export default CompanyDashboardCompanyCompassLayout
